module.exports = __webpack_public_path__ + "img/convenient.5a81a282.jpg";